import axios from 'axios'
import * as ConstantsBase from '../Constants/base'
import { environmentConfig } from '../Utility/Utility'

export const CleanersAdminDownloadSchedule = async (UserId,AuthStr) => {
    const getUrl = environmentConfig();
    const requestUrl = getUrl + ConstantsBase.DownloadCleanerSchedule+UserId
  
    try {
      const data = await axios({
        method: 'get',
        url: requestUrl,
        headers: { 'Content-Type': 'application/json;' ,Authorization :AuthStr},
        validateStatus: function (status) { return status >= 200 }
      })
      return data;
    }
  
    catch (e) {
      return e;
    }
  }